import { Injectable, inject } from "@angular/core";
import { WizardAbstractService } from "./wizard-abstract.service";
import { WizardStep } from "@app/core/model/wizard-step";
import { WizardIdEnum } from "@app/core/model/enum/wizard-id.enum";
import { ContextService } from "@app/core/service/context.service";

@Injectable({
    providedIn: 'root'
})
export class VisibiliteStocksWizardService extends WizardAbstractService {
    private readonly contextService = inject(ContextService);

    constructor() {
        super();
        this.initRoute = '/offers';
        this.idWizard = WizardIdEnum.VISIBILITE_STOCKS;
        this.label = 'VITAFRAIS: Visibilité des stocks';
        this.description = 'Découvrez la visibilité des stocks pour mieux gérer vos commandes.'

        const stepDiscoverVisibiliteStocks = WizardStep.create('discover-visibilite-stocks', this)
            .withTitle('Nouveau !')
            .withText(`<b>Visibilité des stocks</b><br><br>
                Visualisez dès maintenant notre stock en <b>temps réel !</b><br><br>
                Une mise à jour s'effectue <b>toutes les 3 minutes</b> pour vous fournir l'information la plus précise possible.<br><br>
                <b><u>À noter :</u></b> Les stocks se mettent automatiquement à jour en fonction de la date de livraison que vous choisissez.`)
            .attachTo('#stock-indicator', 'right')
            .waitForElement(2000)
            .addNextButton()
            .build();

        const stepTypesStocks = WizardStep.create('types-stocks', this)
            .withTitle('3 types d\'informations de stock')
            .withText(`🟢 Disponible<br>
                        <span style="white-space: nowrap">🟠 En cours de réapprovisionnement ou nouveauté à venir</span><br>
                        🔴 Indisponibilité fournisseur`)
            .attachTo('#stock-indicator', 'right')
            .waitForElement(2000)
            .addCompleteButton()
            .build();

        this.addStep(stepDiscoverVisibiliteStocks);
        this.addStep(stepTypesStocks);
    }

    override isAvailable(): boolean {
        return this.contextService.isVitafrais();
    }
}